export default __webpack_public_path__ + "assets/check_dark.d4e3cad5.svg";